import { useEffect } from 'react';
import { DARK_QUERY, resolvedTheme, useThemeStore } from '@/store/themeStore';

/**
 * Keeps the page in the chosen theme: follows the operating system while the
 * choice is "system", and puts the result on `<html data-theme>`, where the
 * stylesheet reads it. Mounted once, by the app.
 */
export function useApplyTheme(): void {
  const setSystem = useThemeStore((state) => state.setSystem);
  const theme = useThemeStore(resolvedTheme);

  useEffect(() => {
    const media = globalThis.matchMedia?.(DARK_QUERY);
    if (!media) return;

    const onChange = (event: MediaQueryListEvent): void => setSystem(event.matches ? 'dark' : 'light');
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [setSystem]);

  useEffect(() => {
    document.documentElement.dataset['theme'] = theme;
  }, [theme]);
}
